import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Accessibility, 
  ZoomIn, 
  ZoomOut, 
  Contrast, 
  TextFields,
  Description
} from '@mui/icons-material';
import {
  WidgetWrapper,
  WidgetButton,
  WidgetMenu,
  MenuItem,
  MenuTitle,
  Divider
} from './styles';

const AccessibilityWidget = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [fontSize, setFontSize] = useState(100);
  const [highContrast, setHighContrast] = useState(false);

  const increaseFontSize = () => {
    if (fontSize < 150) {
      const newSize = fontSize + 10;
      setFontSize(newSize);
      document.documentElement.style.fontSize = `${newSize}%`;
    }
  };

  const decreaseFontSize = () => {
    if (fontSize > 80) {
      const newSize = fontSize - 10;
      setFontSize(newSize);
      document.documentElement.style.fontSize = `${newSize}%`;
    }
  };

  const toggleContrast = () => {
    setHighContrast(!highContrast);
    document.body.classList.toggle('high-contrast');
  };

  const toggleDyslexicFont = () => {
    document.body.classList.toggle('dyslexic-font');
  };

  const goToAccessibilityStatement = () => {
    navigate('/accessibility');
    setIsOpen(false);
  };

  return (
    <WidgetWrapper>
      <WidgetButton onClick={() => setIsOpen(!isOpen)}>
        <Accessibility />
      </WidgetButton>
      
      <WidgetMenu isOpen={isOpen}>
        <MenuTitle>אפשרויות נגישות</MenuTitle>
        
        <MenuItem onClick={increaseFontSize}>
          <ZoomIn />
          הגדל טקסט
        </MenuItem>
        
        <MenuItem onClick={decreaseFontSize}>
          <ZoomOut />
          הקטן טקסט
        </MenuItem>
        
        <MenuItem onClick={toggleContrast}>
          <Contrast />
          ניגודיות גבוהה
        </MenuItem>
        
        <MenuItem onClick={toggleDyslexicFont}>
          <TextFields />
          פונט נגיש
        </MenuItem>

        <Divider />
        
        <MenuItem onClick={goToAccessibilityStatement}>
          <Description />
          הצהרת נגישות
        </MenuItem>
      </WidgetMenu>
    </WidgetWrapper>
  );
};

export default AccessibilityWidget; 